import {inject, injectable} from 'inversify';

import type {VoiceAttachmentStateOptions} from './types';

import {AudioModelFactory} from '../../../../../../core/models/Audio/AudioModel.factory';
import {VoiceAttachmentState} from './VoiceAttachmentState';

@injectable()
export class VoiceAttachmentStateFactory {
  constructor(
    @inject(AudioModelFactory)
    private readonly audioModelFactory: AudioModelFactory,
  ) {}

  create(
    id: string,
    options: VoiceAttachmentStateOptions = {
      useQueue: true,
    },
  ) {
    return new VoiceAttachmentState(id, options, this.audioModelFactory);
  }
}
